<template>
    <div v-loading="loading">
        <!--banner-->
        <div class="nbanner" v-if="$util.isEmpty(keyword)">
            <a :href="item.adv_url?item.adv_url.url:'javascript:void(0)'" :target="item.adv_url?'_blank':''" v-for="item in bannerlist" :key="item.adv_id">
               <img :src="$util.img(item.adv_image)" alt="">
            </a> 
            <!-- <img v-if="bannerlist.length<=0" src="@/assets/styles/images/ny4.png" alt=""> -->
        </div>
        <!--主体开始-->
        <div class="nding" v-if="!$util.isEmpty(keyword)">
            <div>
                <p>当前位置：</p>
                <a href="/home">首页</a>&gt; <a href="/pricequotes/list">价格行情</a>&gt; <a href="">{{keyword}}</a>
                <p style="float: right">共找到{{salescount}}条“{{keyword}}”销地信息，{{sourcescount}}条产地信息</p>
            </div>
        </div>
        <div class="fenlei" id="areaselect" style="display:none">
            <div class="xia1" style="display: flex;flex-direction: row;justify-content: space-between">
                <ul class="poster-txt xg" style="height: 40px;">
                    <h4>地区</h4>
                    <div>
                        <li><a :class="$util.isEmpty(areacode) ? 'on' : ''" href="javascript:void(0)" @click="changeArea('')">不限</a></li>
                        <li v-for="item in areas" :key="item.id"><a :class="item.id == areacode ? 'on' : ''" href="javascript:void(0)" @click="changeArea(item.id)">{{item.shortname}}</a></li>
                    </div>
                </ul>
                <div class="poster-btn"><a href="javascript:void(0);">展开更多</a></div>
            </div>
        </div>
        <div class="fenlei" style="border: #e5e5e5 1px solid">
            <ul class="sh">
                <li><a :class="$util.isEmpty(category_id) ? 'on' : ''" href="javascript:void(0)" @click="alltypes()">全部</a></li>
                <li v-for="item in categoryList" :key="item.category_id"><a :class="item.category_id == category_id_1 ? 'on' : ''" @click="getChild(item.category_id)" href="javascript:void(0)">{{item.category_name}}</a></li>
            </ul>
            <div class="xia1">
                <ul v-for="item in childList" :key="item.category_id">
                    <h4>{{item.category_name}}</h4>
                    <div>
                        <li v-for="i in item.child_list" :key="i.category_id"><a :class="i.category_id == category_id ? 'on' : ''" href="javascript:void(0);" @click="getAttr(i.category_id, i.attr_class_id)">{{i.category_name}}</a></li>
                    </div>
                </ul>
            </div>
        </div>
        <div class="fenlei" style="border: #e5e5e5 1px solid" v-if="isshow">
            <div class="xia1">
                <ul>
                    <h4>品种</h4>
                    <div>
                        <li v-for="item in attrList" :key="item.attr_value_id"><a :class="attr_id == item.attr_value_id ? 'on' : ''" href="javascript:void(0);" @click="changeAttr(item.attr_value_id)">{{item.attr_value_name}}</a></li>
                    </div>
                </ul>
            </div>
        </div>
        <section class="section ncontainer1 tab-wrapper">
            <ul class="tab-menu">
                <li class="active" id="xd">销地价格</li>
                <li id="cd">产地价格</li>
            </ul>
            <div class="tab-content">
                <div>
                    <div class="tj3">
                        <div class="loop_top">
                            <ol class="head">
                                <li>产品品类</li>
                                <!-- <li>品种</li> -->
                                <li>批发市场 </li>
                                <li>价格日期 </li>
                                <li>价格 </li>
                                <li>涨跌 </li>
                            </ol>
                            <ul class="list">
                                <li v-for="item in salesPage" :key="item.id" class="new-list">
                                    <span>{{item.categoryname}}{{!$util.isEmpty(item.attr_value_name) ? '(' + item.attr_value_name + ')' : ''}}</span>
                                    <!-- <span>{{item.attr_value_name}}</span> -->
                                    <span>{{item.marketname}}</span>
                                    <span>{{ $util.timeStampTurnTime(item.gathertime, 'YYYY-MM-DD') }}</span>
                                    <span>{{item.price}}<i>元/{{item.unit}}</i></span>
                                    <span>
                                        <img v-if="item.updown == 0" src="@/assets/styles/images/s1.png" @click="details(item.id)" alt="">
                                        <img v-if="item.updown == -1" src="@/assets/styles/images/s2.png" @click="details(item.id)" alt="">
                                        <img v-if="item.updown == 1" src="@/assets/styles/images/s3.png" @click="details(item.id)" alt="">
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="pages">
                        <div class="Pagination Pagination_sales"></div>
                        <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
                    </div>
                </div>
                <div>
                    <div class="tj3">
                        <div class="loop_top">
                            <ol class="head">
                                <li>产品品类</li>
                                <!-- <li>品种</li> -->
                                <li>地区 </li>
                                <li>价格日期 </li>
                                <li>价格 </li>
                                <li>涨跌 </li>
                            </ol>
                            <ul class="list">
                                <li v-for="item in sourcesPages" :key="item.id" class="new-list">
                                    <span>{{item.categoryname}}{{!$util.isEmpty(item.attr_value_name) ? '(' + item.attr_value_name + ')' : ''}}</span>
                                    <!-- <span>{{item.attr_value_name}}</span> -->
                                    <span>{{item.areaname}}</span>
                                    <span>{{ $util.timeStampTurnTime(item.gathertime, 'YYYY-MM-DD') }}</span>
                                    <span>{{item.price}}<i>元/{{item.unit}}</i></span>
                                    <span>
                                        <img v-if="item.updown == 0" src="@/assets/styles/images/s1.png" @click="details(item.id)" alt="">
                                        <img v-if="item.updown == -1" src="@/assets/styles/images/s2.png" @click="details(item.id)" alt="">
                                        <img v-if="item.updown == 1" src="@/assets/styles/images/s3.png" @click="details(item.id)" alt="">
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="pages">
                        <div class="Pagination Pagination_sources"></div>
                        <!-- <div class="searchPage"> <span class="page-sum">共<strong class="allPage">{{pageCount}}</strong>页</span></div> -->
                    </div>
                </div>
            </div>
        </section>
        <!--弹出层-->
        <div id="goodcover" style="width: 100%;height: 100%;background: rgba(0,0,0,0.5);opacity: 1">
            <div id="code">
                <div class="close"><a href="javascript:void(0)" id="closebt"><img src="@/assets/styles/images/close.png" alt=""></a></div>
                <div class="hangqingtan" v-loading="detailsloading">
                    <h4 v-if="model.type == 1">{{model.areaname}} {{model.categoryname}}({{model.attr_value_name}}) 七天内价格走势</h4>
                    <h4 v-if="model.type == 2">{{model.marketname}} {{model.categoryname}}({{model.attr_value_name}}) 七天内价格走势</h4>
                    <div class="da">
                        <div class="z">
                            <div class="tu">
                                <div>
                                    <chart style="width:100%;height:300px" id="chartList" :data="chartList" type="line" x="7%" x2="3%" y2="7%"
                                           tip="价格" namefield="gathertime" valuefield="price"></chart>
                                </div>
                                <!-- <h2 v-if="model.type == 1">{{model.areaname}} {{model.categoryname}}({{model.attr_value_name}}) 七天内价格走势</h2>
                                <h2 v-if="model.type == 2">{{model.marketname}} {{model.categoryname}}({{model.attr_value_name}}) 七天内价格走势</h2> -->
                            </div>
                            <ul>
                                <li @click="changeDay(1)"><a href="javascript:void(0)"><img src="@/assets/styles/images/hq3.png" alt=""></a></li>
                                <li>{{ $util.timeStampTurnTime(this.tmp, 'YYYY-MM-DD') }}</li>
                                <li @click="changeDay(2)"><a href="javascript:void(0)"><img src="@/assets/styles/images/hq2.png" alt=""></a></li>
                            </ul>
                        </div>
                        <div class="y">
                            <p>单位：元/{{model.unit}}</p>
                            <h2>当日价格</h2>
                            <p>当日均价：{{model.price}}</p>
                            <p>
                                相对比前日：
                                <img v-if="model.updown == 0" src="@/assets/styles/images/s1.png" style="margin-right:10px" />
                                <img v-if="model.updown == -1" src="@/assets/styles/images/s2.png" style="margin-right:10px" />
                                <img v-if="model.updown == 1" src="@/assets/styles/images/s3.png" style="margin-right:10px" />
                                {{model.percent}}
                            </p>
                            <h2>近7日价格</h2>
                            <p>近7日最高价：{{model.max}}</p>
                            <p>近7日最低价：{{model.min}}</p>
                            <p>近7日均价：{{model.aver}}</p>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    </div>
</template>

<script>
    import '@/assets/styles/js/jquery.pagination.js';
    import chart from "@/components/chart"
    import { pricequotesPage } from '@/api/pricequotes/pricequotes';
    import { pricequotesDetail } from '@/api/pricequotes/pricequotes';
    import { pricequotesDetailByDate } from '@/api/pricequotes/pricequotes';
    import { getArea } from '@/api/address';
    import { getMenuList } from '@/api/goods/goodscategory';
    import { tree } from '@/api/goods/goodscategory';
    import { getAttrValueList } from '@/api/goods/goodscategory';
    import { adList } from "@/api/website";

    export default {
        name: '',
        components: {
            chart
        },
        data: () => {
            return {
                loading: true,
                detailsloading: true,
                salesPage:[],
                sourcesPages:[],
                pageCount:0,
                page_size:10,
                page:1,

                model:{},
                chartList:[],
                tmp:'',
                todaytmp:'',
                type:2,

                areas:[],
                areacode:'',
                attr_id:'',
                category_id:'',
                category_id_1:'',
                categoryList:[],
                childList:[],
                attrList:[],
                isshow:false,
                keyword:'',
                salescount:0,
                sourcescount:0,
                bannerlist:[],
            };
        },
        created() {
            this.keyword = this.$route.query.keyword;
            $(function(){
                $(".poster-btn").click(function(){
                    if ($(this).text() == "展开更多") {
                        $(this).html('<a href="javascript:void(0);">点击收起</a>');
                        $(this).siblings(".poster-txt").removeClass("xg").css("height","auto");
                        $(this).addClass('current-menu').siblings().removeClass('current-menu');
                    }else{
                        $(this).html('<a href="javascript:void(0);">展开更多</a>');
                        $(this).siblings(".poster-txt").addClass("xg").css("height","40px");
                        $(this).removeClass('current-menu').siblings().addClass('current-menu');
                    }
                });
            })

            var date = new Date();
            var year = date.getFullYear();
            var month = date.getMonth() + 1;
            var day = date.getDate();
            var datestr = year + "-" + month + "-" + day;
            var tmp = Date.parse( new Date(datestr) ).toString();
            this.todaytmp = tmp.substr(0,10);

            this.getAreas();
            this.getTrees();
            this.getpricePage(2);
            this.getpricePage(1);
            this.getbannerlist();
        },

        methods: {
            getbannerlist() {
                adList({
                    keyword:"PC_PRICE_BANNER"
                }).then(res => {
                    if(res.code == 0) {
                        this.bannerlist = res.data.adv_list.slice(0,1);
                        for (let i = 0; i < this.bannerlist.length; i++) {
                            if (this.bannerlist[i].adv_url) this.bannerlist[i].adv_url = JSON.parse(this.bannerlist[i].adv_url)
                        }
                    }
                })
            },
            getpricePage(type) {
                pricequotesPage({
                    type:type,
                    page_size: this.page_size,
                    page: this.page,
                    areacode: this.areacode,
                    category_id: this.category_id,
                    attr_value_id: this.attr_id,
                    keyword: this.keyword
                }).then(res => {
                    if(res.code == 0) {
                        this.pageCount = res.data.page_count;
                        if(type == 1)
                        {
                            $(".Pagination_sources").pagination(this.pageCount, {
                                callback: this.changesources
                            });
                            this.sourcesPages = res.data.list;
                            this.sourcescount = res.data.count;
                        }
                        else
                        {
                            $(".Pagination_sales").pagination(this.pageCount, {
                                callback: this.changesales
                            });
                            this.salesPage = res.data.list;
                            this.salescount = res.data.count;
                        }
                        this.loading = false;

                    }
                }).catch(err => {
                    this.loading = false;
                    // this.$message.error(err.message);
                })
            },
            getAreas() {
                getArea({

                }).then(res => {
                    if(res.code == 0) {
                        this.areas = res.data;
                    }
                })
            },
            getTrees() {
                tree({
                    level:1
                }).then(res => {
                    if(res.code == 0) {
                        this.categoryList = res.data;
                        // if(this.categoryList.length>0) {
                        //     this.getChild(this.categoryList[0].category_id);
                        // }
                    }
                });
            },
            getChild(id) {
                this.category_id_1 = id;
                this.isshow = false;
                this.category_id = id;
                this.attr_id = '';
                getMenuList({
                    pid: id
                }).then(res => {
                    if(res.code == 0) {
                        this.childList = res.data;
                    }
                });
                this.getpricePage(2);
                this.getpricePage(1);
            },
            getAttr(category_id, attr_class_id) {
                this.attr_id = '';
                this.category_id = category_id;
                this.getpricePage(2);
                this.getpricePage(1);
                getAttrValueList({
                    attr_class_id: attr_class_id
                }).then(res => {
                    if(res.code == 0) {
                        this.attrList = res.data;
                        if(this.attrList.length>0) {
                            this.isshow = true;
                        }
                    }
                });
            },
            changeAttr(id) {
                this.attr_id = id;
                this.getpricePage(2);
                this.getpricePage(1);
            },
            alltypes() {
                this.category_id = '';
                this.category_id_1 = '';
                this.attr_id = '';
                this.childList = [];
                this.attrList = [];
                this.isshow = false;
                this.getpricePage(2);
                this.getpricePage(1);
            },
            changeArea(id) {
                this.areacode = id;
                this.getpricePage(2);
                this.getpricePage(1);
            },
            getDetails(id) {
                this.detailsloading = true;
                this.model = {};
                this.chartList = [];
                pricequotesDetail({
                    id: id
                }).then(res => {
                    if(res.code == 0)
                    {
                        this.model = res.data;
                        this.tmp = this.model.gathertime;
                        this.chartList = res.data.sevendays_list;
                        this.chartList.forEach(function(item) {
                            item.gathertime = util.timeStampTurnTime(item.gathertime, 'MM-DD');
                        });
                        this.detailsloading = false;
                    }
                }).catch(err => {
                    this.detailsloading = false;
                    //this.$message.error(err.message);
                });
            },
            changesales(page_id) {
                this.loading = true;
                this.page = page_id + 1;
                pricequotesPage({
                    type:2,
                    page_size: this.page_size,
                    page: this.page,
                    areacode: this.areacode,
                    category_id: this.category_id,
                    attr_value_id: this.attr_id,
                    keyword: this.keyword
                }).then(res => {
                    if(res.code == 0) {
                        this.salesPage = res.data.list;
                        this.loading = false;
                    }
                });
            },
            changesources(page_id) {
                this.loading = true;
                this.page = page_id + 1;
                pricequotesPage({
                    type:1,
                    page_size: this.page_size,
                    page: this.page,
                    areacode: this.areacode,
                    category_id: this.category_id,
                    attr_value_id: this.attr_id,
                    keyword: this.keyword
                }).then(res => {
                    if(res.code == 0) {
                        this.sourcesPages = res.data.list;
                        this.loading = false;
                    }
                });
            },
            details(id) {
                this.getDetails(id);
                $('#code').center();
                $('#goodcover').show();
                $('#code').fadeIn();
            },
            changeDay(type) {
                if(type == 2 && this.tmp == this.todaytmp)
                {
                    this.$message.warning("已经是最后一天");
                    return;
                }
                this.detailsloading = true;

                var tmp = type == 1 ? this.tmp - 3600 * 24 : this.tmp + 3600 * 24;
                var params = {};
                if(this.model.type == 1)
                {
                    params = {type: this.model.type, gathertime: tmp, attr_value_id: this.model.attr_value_id, areacode: this.model.areacode}
                }
                else
                {
                    params = {type: this.model.type, gathertime: tmp, attr_value_id: this.model.attr_value_id, market_id: this.model.market_id}
                }
                pricequotesDetailByDate(params).then(res => {
                    if(res.code == 0)
                    {
                        this.tmp = tmp;
                        this.chartList = [];
                        this.model.aver = res.data.aver;
                        this.model.max = res.data.max;
                        this.model.min = res.data.min;
                        this.model.percent = res.data.percent;
                        this.model.price = res.data.price;
                        this.model.updown = res.data.updown;
                        this.chartList = res.data.sevendays_list;
                        this.chartList.forEach(function(item) {
                            item.gathertime = util.timeStampTurnTime(item.gathertime, 'YYYY-MM-DD');
                        });
                        this.detailsloading = false;
                    }
                    if(res.code == -1)
                    {
                        this.$message.warning(res.message);
                    }
                }).catch(err => {
                    this.detailsloading = false;
                    //this.$message.warning(err.message);
                });
            }
        },
        mounted () {
            $(function() {
                //alert($(window).height());
                $('.tab-wrapper .tj3 .loop_top .list li  span:nth-child(5)').click(function() {
                    $('#code').center();
                    $('#goodcover').show();
                    $('#code').fadeIn();
                });
                $('#closebt').click(function() {
                    //$('#code').hide();
                    $('#goodcover').hide();
                });
                jQuery.fn.center = function(loaded) {
                    var obj = this;
                    var body_width = parseInt($(window).width());
                    var block_width = parseInt(obj.width());
                    var left_position = parseInt((body_width / 2) - (block_width / 2) + $(window).scrollLeft());

                    if (!loaded) {

                        obj.css({
                            'position': 'absolute'
                        });
                        obj.css({
                            'top': ($(window).height() - $('#code').height()) * 0.5,
                            'left': left_position
                        });
                        $(window).bind('resize', function() {
                            obj.center(!loaded);
                        });
                        $(window).bind('scroll', function() {
                            obj.center(!loaded);
                        });

                    } else {
                        obj.stop();
                        obj.css({
                            'position': 'absolute'
                        });
                    }
                }

            })


            var _that = this;
            $(document).ready(function() {

                var $wrapper = $('.tab-wrapper'),
                    $allTabs = $wrapper.find('.tab-content > div'),
                    $tabMenu = $wrapper.find('.tab-menu li'),
                    $line = $('<div class="line"></div>').appendTo($tabMenu);

                $allTabs.not(':first-of-type').hide();
                $tabMenu.filter(':first-of-type').find(':first').width('100%')

                $tabMenu.each(function(i) {
                    $(this).attr('data-tab', 'tab'+i);
                });

                $allTabs.each(function(i) {
                    $(this).attr('data-tab', 'tab'+i);
                });


                $tabMenu.on('click', function() {
                    var dataTab = $(this).data('tab'),
                        $getWrapper = $(this).closest($wrapper);

                    $getWrapper.find($tabMenu).removeClass('active');
                    if($(this)[0].id == "cd") {
                        $("#areaselect").css("display", "block");
                        _that.type = 1;
                    }
                    else {
                        $("#areaselect").css("display", "none");
                        _that.type = 2;
                    }
                    $(this).addClass('active');

                    $getWrapper.find('.line').width(0);
                    $(this).find($line).animate({'width':'100%'}, 'fast');
                    $getWrapper.find($allTabs).hide();
                    $getWrapper.find($allTabs).filter('[data-tab='+dataTab+']').show();
                });

            });
        }

    }
</script>

<style lang="scss"  scoped>
%cursor-type {
    cursor: pointer;
}
.loop_top{
    .list{
        li span:nth-child(5) img:hover{
            @extend %cursor-type;
        }
    }
}
</style>
